// NG 2
import { Injectable, OnInit } from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';
// APP
import { AppConfig } from '../app.config';
import { BaseService } from './base.service';



@Injectable()
export class LoginService extends BaseService {
    _baseUrl: string = AppConfig.config.baseCPUIUrl; 
    _bypassLoginUrl: string = AppConfig.config.defaultServicePath;  

    public static cpuiLoginResult: any;

    constructor(private http: Http) {
        super();
    }

    getLoginInfo() {

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this._baseUrl + 'GetLoginInfo', JSON.parse(JSON.stringify({ isSessionActive: '' } || null)))
            .map(data => data.json())
            .catch(this.errorHandler);
    }

    getHeaderHTML() {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        return this.http.post(this._baseUrl + 'GetHeaderHTML', JSON.parse(JSON.stringify({ appName: 'HPD Mandatory Inclusionary Housing' } || null)))
            .map(res => res.json())
            .catch(this.errorHandler);
    }

	/*
    LoginByPass(emailId, guid) {
        return this.http.get(this._bypassLoginUrl + 'LoginByPass?emailId=' + emailId + '&guid=' + guid, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
         
    }
	*/
}